<div class="section">
    <div class="container">
        <div class="footer-wrap"><a routerLink="/" target="_blank" class="webflow-link w-inline-block"><img src="./assets/img/small_logo.png" width="230" alt="Logotipo da Dikanza 3D" class="webflow-logo-tiny"></a></div>
    </div>
</div>